// extracted by mini-css-extract-plugin
export default {"spinner":"NotificationIcon_spinner__Gg0KH"};